<template>
  <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="moveParentRouter()">arrow_back</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('126')}}
                                <!-- 과제물 작성 -->
                            </div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="bookmark" alt="bookmark"></a>
                        </section>
                    </div>
                    
                </header>

                
                <section class="flex-grow-1 h-full overflow-hidden">
                    <div class="d-flex flex-column justify-content-between align-content-center h-full">
                        <div class="flex-grow-1 h-full scroll-y">
                            <div class="pda-default mgt-8">
                                <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" ref="answerEl">
                                    <!-- <div class="mdc-text-field-character-counter"></div> -->
                                    <textarea class="mdc-text-field__input" rows="5"
                                        v-model="text"
                                    ></textarea>
                                    <div class="mdc-notched-outline">
                                        <div class="mdc-notched-outline__leading"></div>
                                        <div class="mdc-notched-outline__notch">
                                            <label for="text-field-hero-input" class="mdc-floating-label">
                                                {{$t('127')}}
                                                <!-- 답안 입력 -->
                                            </label>
                                        </div>
                                        <div class="mdc-notched-outline__trailing"></div>
                                    </div>
                                </div>
                                <div class="mgt-16">
                                    <button class="mdc-button mdc-button--raised btn-white w-full" @click="addFiles()">
                                        {{$t('128')}}
                                        <!-- 파일 추가 -->
                                    </button>
                                    <input type="file" id="files" ref="files" multiple  accept="image/*" @change="uploadFile()" class="d-none"/>
                                </div>
                            </div>
                            <hr class="divider">
                            <div class="pda-default">
                                <div class="mdc-card mdc-elevation--z2 pda-default mgt-16" v-if="attachments.length">
                                    <div class="t-subtitle2">
                                        {{$t('129')}}
                                            <!-- 첨부파일 -->
                                    </div>
                                    <div class="t-body3 mgt-30 d-flex flex-row justify-content-between align-content-center"  v-for="(attachment, index) in attachments" :key="index">
                                        <div>
                                            <img src="@/assets/tip.svg" alt="" class="icon">
                                        </div>
                                        <div class="flex-grow-1 mgl-4 mgr-4 t-color-gray2 t-line-1">
                                            {{attachment.originalName}}
                                        </div>
                                        <div class="t-nowrap">
                                            <span class="t-color-red1" @click="deleteFileIndex(index)">
                                                {{$t('130')}}
                                                <!-- 삭제 -->
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </section>
                
                

                
                <section>
                    <div class="pda-default">
                        <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="isUpdate ? missionUpdate() : missionSubmit()" :disabled="!isSetAnswer">
                            {{$t('131')}}
                            <!-- 과제물 제출하기 -->
                        </button>
                    </div>
                </section>

                
            </div>
        </div>
        
        
    </div>
</template>

<script>
/**
 * 나의 학습 상세 - 미션 제출 / 수정 컴포넌트(my learning view - mission submit component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import { topAppBarMixin } from '@/mixins/topAppBar.js'
import { MDCTextField } from '@material/textfield'
import httpService from '@/api/httpService.js'
import { fileMixin } from '@/mixins/file.js'

export default {
    data() {
        return {
            answerEl: null,
            text: '',
            missionData: null,
            answerId: null,
            
        }
    },
    mixins: [topAppBarMixin, fileMixin],
    
    mounted() {
        this.answerEl = new MDCTextField(this.$refs.answerEl)

        // 미션 수정일 때 제출한 답변 가져오기(get answers submitted for mission revisions)
        if (this.$route.name === 'LearnViewMissionUpdate') {
            let params = {
                learnId: this.$route.params.learnId,
                assignmentId: this.$route.params.assignmentId
            }

            learnApi.learnViewMissionView(params).then((response) => {
                this.missionData = response.data.data
                console.log('this.missionData', this.missionData);
                this.attachments = this.missionData.answer.file
                this.answerId = this.missionData.answer.id
                this.text = this.missionData.answer.text
                
                this.answerEl.value = this.text

            })
        }
        
    },

    computed: {

        // 답안 입력 체크(validation answer)
        isSetAnswer() {
            return !!this.text || !!this.attachments.length
        },

        // 수정 모드 체크(check update mode)
        isUpdate() {
            return !!this.answerId
        }
    },

    methods: {

        // 미션 답안 제출(submit  mission answer)
        missionSubmit() {
            let params = {
                learnId: this.$route.params.learnId,
                assignmentId: this.$route.params.assignmentId,
                text: this.text,
                file: this.attachments
            }

            learnApi.learnViewMissionSubmit(params).then((response) => {
                this.$parent.fatchData()
                this.$router.push({
                    name: 'LearnViewMission'
                })
            }).catch((err) => {
                this.errorAlert()
            })
        },

        // 미션 답안 수정(update mission answer)
        missionUpdate() {
            let params = {
                answerId: this.answerId,
                learnId: this.$route.params.learnId,
                assignmentId: this.$route.params.assignmentId,
                text: this.text,
                file: this.attachments
            }

            learnApi.learnViewMissionUpdate(params).then((response) => {
                console.log('learnViewMissionUpdate', response.data.data)
                this.$parent.fatchData()
                this.$router.push({
                    name: 'LearnViewMission'
                })
            }).catch((err) => {
                this.errorAlert()
            })
        },

        // 미션 제출 오류 메시지(error)
        errorAlert() {
            this.$alert({
                title: 'TODO-과제 제출 오류',
                content: 'TODO-과제를 제출하던 중 오류가 발생하였습니다.',
                accept:  'TODO-확인' //확인
            }).then(() => {
                this.$router.push({
                    name: 'LearnViewMission'
                })
            })
        }
    },
}
</script>